export default {
  showRedirectToPaymentModal: false,
  showRedirectToLastRouteModal: false,
  plans: [],
  plansLoading: false,
  currentPlan: null,
  promoCampaign: null,
}
